<template>

  <div>

    <p class="text-align-center input-error-message" v-if="error_message">{{error_message}}</p>

    <div class="container">

      <div class="column-100">
        <label>Month*</label>
        <input :class="{'validate-error':error_message}" type="tel" name="date_of_birth[month]" v-mask="'##'" v-model="mm" min="01" max="12" maxlength="2"  :placeholder=" 'MM' + (is_required ? '*' : '') " step="1" />
      </div>

      <div class="column-100">
        <label>Day*</label>
        <input :class="{'validate-error':error_message}" type="tel" name="date_of_birth[day]" v-mask="'##'" v-model="dd" min="01" max="31" maxlength="2"  :placeholder=" 'DD' + (is_required ? '*' : '') " step="2" />
      </div>

      <div class="column-100">
        <label>Year*</label>
        <input :class="{'validate-error':error_message}" type="tel" name="date_of_birth[year]" v-mask="'####'" v-model="yy" min="1900" :max="$store.getters.current_year" maxlength="4"  :placeholder=" 'YYYY' + (is_required ? '*' : '') " step="3"/>
      </div>

    </div>

  </div>

</template>

<script>
    import {fields} from '../../mixins/requests/fields'
    import {field_component_mixin} from './field_component_mixin'

    export default {
        name: "date_of_birth",
        mixins: [fields, field_component_mixin],
        data(){
          return{
              field_name: "date_of_birth"
          }
        },
        methods: {
            auto_tab: function () {

                var inputs = $('input[step]')

                inputs.each(function (k, v) {
                    $(this).on('input', function () {
                        if ($(this).val().length == $(this).attr('maxlength') && $(this).attr('step') != inputs.length) {
                            var step = parseInt($(this).attr('step')) + 1;
                            $('input[step = ' + step + ']').focus();
                        }
                    })
                })
            },
        },
        computed: {

        },
        mounted(){
            this.auto_tab()
        }
    }
</script>

<style scoped>
</style>